<template>
  <v-btn
    class="py-6 d-flex flex-row justify-start"
    @click="connectToFacebook"
  >
    <v-img
      :src="KindTypeIcon.facebookPost"
      width="30"
      height="30"
      class="mr-2 flex-grow-0"
    />
    {{ $t('buttons.social-media.connect-facebook') }}
  </v-btn>
</template>

<script>
import { SocialMedia } from '../../enums/SocialMedia'
import {
  facebookSDKInitialized,
  initFbSDK,
  loginToFacebook
} from '@/lib/facebook'
import { KindTypeIcon } from '../../enums/KindType'
import feature from '@/mixins/feature'

export default {
  mixins: [feature],
  props: {
    connectionWrapper: {
      type: Function,
      required: true
    },
    featureConfig: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      KindTypeIcon
    }
  },
  methods: {
    async connectToFacebook () {
      if (!this.featureConfig.postToFacebook) {
        this.$emit('featureEnabled', false)
        return
      }

      await this.connectionWrapper('Facebook', async () => {
        if (!facebookSDKInitialized()) {
          await initFbSDK()
        }
        const login = await loginToFacebook()
        return {
          accessToken: login.authResponse.accessToken,
          userId: login.authResponse.userID,
          type: SocialMedia.FACEBOOK
        }
      })
    }
  }
}
</script>
